/**
 * EN-1448: a random UUID v4 naming one lease session. Never throws: `hold()` runs synchronously on the
 * recorder path, and `crypto.randomUUID` only exists in secure contexts (missing on a plain-http LAN dev URL
 * and in jsdom).
 */
export function newLeaseHolder(): string {
    try {
        if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    } catch {
        // Fall through to the manual build below.
    }
    const bytes = new Uint8Array(16);
    try {
        crypto.getRandomValues(bytes);
    } catch {
        // Last resort, not cryptographic: fine because a holder only names a lease session, it is not a credential.
        for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
